var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.6648 14.5C15.0959 13.2747 15.9466 12.2415 17.0664 11.5834C18.1862 10.9253 19.5028 10.6847 20.783 10.9043C22.0632 11.1238 23.2243 11.7894 24.0608 12.7831C24.8973 13.7768 25.3551 15.0344 25.3532 16.3333C25.3532 20 19.8532 21.8333 19.8532 21.8333M19.9998 29.1666H20.0182M38.3332 20C38.3332 30.1252 30.1251 38.3333 19.9998 38.3333C9.87462 38.3333 1.6665 30.1252 1.6665 20C1.6665 9.87474 9.87462 1.66663 19.9998 1.66663C30.1251 1.66663 38.3332 9.87474 38.3332 20Z",
    stroke: "#1E1E1E",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.8d795ee91be4ca4bc6cbeeb54e35d9ad.svg";
export { ForwardRef as ReactComponent };